import * as Form from "@radix-ui/react-form";
import { LocalizedMessage } from "_shared/localization/LocalizedMessage";
import { SmallText } from "_shared/text/SmallText";

/**
 * Use within {@link Form.Field} to show an error message when an integer input is invalid.
 */
export function InvalidIntMessage() {
  return (
    <Form.Message match="patternMismatch">
      <SmallText color="warning">
        <LocalizedMessage id="input_error_whole_number" />
      </SmallText>
    </Form.Message>
  );
}
